<div class="tpl3pl-page-container sku-push-page">

	<h6 class="text-muted text-uppercase small font-weight-bold mb-2 section-push-heading">Push product master (PGS)</h6>

	<!-- ── SKU push: filters & actions ───────────────────────────────────────── -->
	<div class="top-bar">
		<div class="top-bar-left">
			<mat-form-field appearance="outline" class="field-search">
				<mat-label>Search SKU / description</mat-label>
				<input matInput [ngModel]="searchInput" (ngModelChange)="onSearchInput($event)">
				<mat-icon matSuffix>search</mat-icon>
			</mat-form-field>

			<mat-form-field appearance="outline" class="field-status">
				<mat-label>Push status</mat-label>
				<mat-select [ngModel]="statusFilter" (ngModelChange)="onStatusFilter($event)">
					<mat-option value="">All</mat-option>
					<mat-option value="pending">Pending</mat-option>
					<mat-option value="success">Success</mat-option>
					<mat-option value="failed">Failed</mat-option>
				</mat-select>
			</mat-form-field>

			<mat-form-field appearance="outline" class="field-inv">
				<mat-label>3PL inventory filter</mat-label>
				<mat-select [ngModel]="invFilter" (ngModelChange)="onInvFilter($event)">
					<mat-option value="">All</mat-option>
					<mat-option value="not_in_feed">Not in inventory pull</mat-option>
					<mat-option value="in_feed">In inventory feed (3PL reports SKU)</mat-option>
					<mat-option value="synced_only">All warehouses synced</mat-option>
					<mat-option value="inv_error">Any inventory sync error</mat-option>
					<mat-option value="pending_only">Inventory pending only</mat-option>
					<mat-option value="push_ok_no_inv">Push OK but not in inventory pull</mat-option>
				</mat-select>
			</mat-form-field>

			<mat-form-field appearance="outline" class="field-list-sort"
				matTooltip="Newest first uses stockmaster.date_created so newly added ERP items appear at the top.">
				<mat-label>List order</mat-label>
				<mat-select [ngModel]="listSort" (ngModelChange)="onListSortChange($event)">
					<mat-option value="stockid">SKU A–Z</mat-option>
					<mat-option value="newest">Newest in ERP first</mat-option>
				</mat-select>
			</mat-form-field>

			<mat-form-field appearance="outline" class="field-created-within"
				matTooltip="Only SKUs with a non-empty date_created in stockmaster within this window. Legacy rows without a date are excluded when a window is set.">
				<mat-label>Created in ERP</mat-label>
				<mat-select [ngModel]="createdWithinDays" (ngModelChange)="onCreatedWithinChange($event)">
					<mat-option [value]="0">Any time</mat-option>
					<mat-option [value]="7">Last 7 days</mat-option>
					<mat-option [value]="30">Last 30 days</mat-option>
					<mat-option [value]="90">Last 90 days</mat-option>
					<mat-option [value]="365">Last 365 days</mat-option>
				</mat-select>
			</mat-form-field>

			<mat-form-field appearance="outline" class="field-brand"
				matTooltip="Limit the list to SKUs linked to this manufacturer (brand) in product_to_manufacturer. Still respects 3PL config category/line/brand scope.">
				<mat-label>Brand</mat-label>
				<mat-select [ngModel]="brandFilterManufacturerId" (ngModelChange)="onBrandFilterChange($event)">
					<mat-option [value]="0">All brands</mat-option>
					<mat-option *ngFor="let b of brands" [value]="b.manufacturer_id">
						{{ b.name }}<ng-container *ngIf="b.mfg_code"> ({{ b.mfg_code }})</ng-container>
					</mat-option>
				</mat-select>
			</mat-form-field>

			<mat-checkbox
				class="field-new-skus-only"
				[ngModel]="listNotInInventoryFeedOnly"
				(ngModelChange)="onListNotInInventoryFeedOnlyChange($event)"
				matTooltip="Server filters the list to SKUs with no rows in tpl3pl_inventory (not seen on the last inventory pull). Total count and paging use this scope. Combine with Newest / Created in ERP for newly added items.">
				List: not in inventory pull
			</mat-checkbox>

			<span class="count-chip">{{ loadedLabel }}</span>
			<span class="result-chip result-ok"   *ngIf="successCount > 0"><mat-icon>check_circle</mat-icon> {{ successCount }} ok</span>
			<span class="result-chip result-fail" *ngIf="failedCount  > 0"><mat-icon>error</mat-icon> {{ failedCount }} failed</span>
		</div>

		<div class="top-bar-right">
			<button mat-icon-button (click)="reload()" [disabled]="loading || loadingMore || batchRunning" matTooltip="Reload SKU list">
				<mat-icon>refresh</mat-icon>
			</button>
			<button mat-stroked-button (click)="exportOutboundJson()" [disabled]="exportOutboundBusy || loading || loadingMore || batchRunning"
				matTooltip="Download exact POST /api/Sku JSON for each SKU (ERP→PGS). Uses current list filters on the server; if any rows are checked, exports only those. Does not call PGS.">
				<mat-icon *ngIf="!exportOutboundBusy">cloud_download</mat-icon>
				<mat-spinner *ngIf="exportOutboundBusy" diameter="18" class="btn-inline-spinner"></mat-spinner>
				Outbound JSON
			</button>
			<button mat-stroked-button (click)="exportOutboundCsv()" [disabled]="exportOutboundBusy || loading || loadingMore || batchRunning"
				matTooltip="Same outbound fields as JSON, flattened to CSV (SKU, UPC, descriptions, CompanyID, dims, weights, …).">
				<mat-icon *ngIf="!exportOutboundBusy">table_chart</mat-icon>
				<mat-spinner *ngIf="exportOutboundBusy" diameter="18" class="btn-inline-spinner"></mat-spinner>
				Outbound CSV
			</button>
			<button mat-stroked-button (click)="exportXls()" [disabled]="savedResults.size === 0 || exporting" matTooltip="Export to Excel (server print/xls)">
				<mat-icon>grid_on</mat-icon> Export XLSX
			</button>
			<button mat-stroked-button (click)="exportPdf()" [disabled]="savedResults.size === 0 || exporting" matTooltip="Export to PDF (server print/pdf)">
				<mat-icon>picture_as_pdf</mat-icon> Export PDF
			</button>
		</div>
	</div>

	<div class="csv-filter-bar">
		<div class="csv-filter-header" (click)="csvPanelOpen = !csvPanelOpen">
			<mat-icon class="csv-toggle-icon">{{ csvPanelOpen ? 'expand_less' : 'expand_more' }}</mat-icon>
			<span class="csv-filter-title">Filter by SKU list</span>
			<span class="csv-active-badge" *ngIf="csvSet && csvSet.size > 0">
				{{ csvMatchCount }} / {{ csvParsedCount }} matched
			</span>
		</div>
		<div class="csv-filter-body" *ngIf="csvPanelOpen">
			<textarea
				class="csv-textarea"
				rows="4"
				placeholder="Paste SKUs separated by commas, spaces, or newlines — quotes are stripped automatically"
				[ngModel]="csvFilter"
				(ngModelChange)="onCsvFilter($event)">
			</textarea>
			<div class="csv-filter-actions">
				<button mat-stroked-button color="primary" (click)="selectFromCsv()" [disabled]="!csvSet || csvSet.size === 0">
					<mat-icon>checklist</mat-icon> Select matched in list
				</button>
				<button mat-stroked-button (click)="clearCsvFilter()" [disabled]="!csvFilter">
					<mat-icon>clear</mat-icon> Clear
				</button>
			</div>
		</div>
	</div>

	<div class="action-bar">
		<div class="action-bar-left">
			<mat-checkbox
				[checked]="allVisibleSelected"
				[indeterminate]="someVisibleSelected"
				(change)="toggleAll()">
				<span class="small">{{ selectedCount ? selectedCount + ' selected' : 'Select all visible' }}</span>
			</mat-checkbox>

			<button mat-stroked-button color="primary"
				(click)="pushSelected()"
				[disabled]="batchRunning || loading || selectedCount === 0">
				<mat-icon>checklist</mat-icon> Push selected ({{ selectedCount }})
			</button>
		</div>

		<div class="action-bar-right">
			<button mat-stroked-button color="warn"
				*ngIf="batchRunning"
				(click)="stopBatchSend()"
				matTooltip="Abort the in-flight batch request immediately; SKUs still sending revert to pending.">
				<mat-icon>stop</mat-icon> Stop send
			</button>

			<span class="start-label">Batch size</span>
			<mat-form-field appearance="outline" class="field-batch-size">
				<input matInput type="number" min="1" max="100" [(ngModel)]="pushBatchSize" placeholder="25"
					[disabled]="batchRunning"
					matTooltip="SKUs per server request (1–100). Default 25.">
			</mat-form-field>

			<span class="start-label">Skip first</span>
			<mat-form-field appearance="outline" class="field-start">
				<input matInput type="number" min="0" [(ngModel)]="startFrom" placeholder="0"
					matTooltip="Skip this many pending/failed rows in the current filter before pushing the rest.">
			</mat-form-field>

			<button mat-raised-button color="primary"
				(click)="pushFromHere()"
				[disabled]="batchRunning || loading">
				<mat-spinner *ngIf="batchRunning" diameter="16" class="btn-spinner"></mat-spinner>
				<mat-icon *ngIf="!batchRunning">send</mat-icon>
				<span *ngIf="!batchRunning">Push pending &amp; failed</span>
				<span *ngIf="batchRunning">{{ batchProgress }}&nbsp;/&nbsp;{{ batchTotal }}…</span>
			</button>
		</div>
	</div>

	<div *ngIf="loading" class="text-center py-5">
		<mat-spinner diameter="36"></mat-spinner>
		<p class="text-muted small mt-2">Loading SKUs…</p>
	</div>

	<div *ngIf="loadingMore && !loading" class="loading-more-bar">
		<mat-spinner diameter="18"></mat-spinner>
		<span>Loading more… {{ allRows.length.toLocaleString() }} of {{ totalCount.toLocaleString() }}</span>
	</div>

	<div class="table-wrap" *ngIf="!loading">
		<table class="sku-table">
			<thead>
				<tr>
					<th class="col-check"></th>
					<th class="col-num">#</th>
					<th class="col-erp-created text-muted small" matTooltip="stockmaster.date_created in ERP">ERP created</th>
					<th class="col-sku">SKU</th>
					<th class="col-desc">Description</th>
					<th class="col-wh" matTooltip="Warehouse code (tpl3pl_inventory)">Wh</th>
					<th class="col-qty text-right" matTooltip="Quantity available (PGS cache)">Avail</th>
					<th class="col-qty text-right" matTooltip="Quantity on hand (PGS cache)">OH</th>
					<th class="col-line-sync" matTooltip="Sync status for this warehouse row">Wh sync</th>
					<th class="col-last-pull" matTooltip="Last time this SKU appeared in an inventory pull">Last pull</th>
					<th class="col-status">Push</th>
					<th class="col-msg">Message</th>
					<th class="col-action"></th>
				</tr>
			</thead>
			<tbody>
				<ng-container *ngFor="let row of filteredRows; let ri = index; trackBy: trackBySku">
					<ng-container *ngFor="let w of row.invWarehouseLines; let wi = index; trackBy: trackByInvLineKey">
						<tr [ngClass]="rowClass(row)">
							<td *ngIf="wi === 0" class="col-check" [attr.rowspan]="row.invWarehouseLines.length">
								<mat-checkbox [checked]="isSelected(row.stockid)" (change)="toggleRow(row.stockid)"></mat-checkbox>
							</td>
							<td *ngIf="wi === 0" class="col-num text-muted small" [attr.rowspan]="row.invWarehouseLines.length">{{ ri + 1 }}</td>
							<td *ngIf="wi === 0" class="col-erp-created text-muted small" [attr.rowspan]="row.invWarehouseLines.length">
								{{ row.dateCreatedErp ? (row.dateCreatedErp | date:'shortDate') : '—' }}
							</td>
							<td *ngIf="wi === 0" class="col-sku" [attr.rowspan]="row.invWarehouseLines.length"><code>{{ row.stockid }}</code></td>
							<td *ngIf="wi === 0" class="col-desc" [attr.rowspan]="row.invWarehouseLines.length" [title]="row.detailTitleCache || ''">
								<div class="desc-text">{{ row.description || '—' }}</div>
							</td>
							<td class="col-wh"><code class="wh-code">{{ w.warehouse_code }}</code></td>
							<td class="col-qty text-right mono">{{ w.quantity_available | number }}</td>
							<td class="col-qty text-right mono">{{ w.quantity_on_hand | number }}</td>
							<td class="col-line-sync">
								<span class="line-sync-pill" [ngClass]="invWhSyncClass(w.sync_status)">{{ w.sync_status }}</span>
							</td>
							<td *ngIf="wi === 0" class="col-last-pull text-muted small" [attr.rowspan]="row.invWarehouseLines.length">
								{{ row.inventory.last_inventory_sync ? (row.inventory.last_inventory_sync | date:'short') : '—' }}
							</td>
							<td *ngIf="wi === 0" class="col-status" [attr.rowspan]="row.invWarehouseLines.length">
								<span class="status-badge" [ngClass]="statusBadgeClass(row)">{{ row.status }}</span>
							</td>
							<td *ngIf="wi === 0" class="col-msg" [attr.rowspan]="row.invWarehouseLines.length" [title]="row.message || ''">{{ row.message || '' }}</td>
							<td *ngIf="wi === 0" class="col-action" [attr.rowspan]="row.invWarehouseLines.length">
								<button mat-icon-button color="primary"
									(click)="pushRow(row)"
									[disabled]="row.status === 'sending' || batchRunning"
									matTooltip="Push this SKU">
									<mat-icon>{{ row.status === 'sending' ? 'hourglass_empty' : 'send' }}</mat-icon>
								</button>
							</td>
						</tr>
					</ng-container>
					<tr *ngIf="row.fullResult" class="detail-row">
						<td colspan="13" class="response-cell">
							<details class="response-details">
								<summary class="response-summary">
									<mat-icon class="summary-icon">code</mat-icon>
									<span>Full request &amp; response</span>
									<button type="button" mat-icon-button class="copy-btn"
										(click)="copyRequestAndResponseJson(row, $event)"
										matTooltip="Copy request + response (JSON)">
										<mat-icon>copy_all</mat-icon>
									</button>
								</summary>
								<div class="req-resp-panels">
									<div class="req-resp-panel" *ngIf="row.cachedRequestJson as reqJson">
										<div class="req-resp-toolbar">
											<span class="req-resp-title">Request</span>
											<button type="button" mat-icon-button class="copy-btn"
												(click)="copyRequestJson(row, $event)"
												matTooltip="Copy request JSON">
												<mat-icon>content_copy</mat-icon>
											</button>
										</div>
										<pre class="json-block json-block-panel">{{ reqJson }}</pre>
									</div>
									<div class="req-resp-panel">
										<div class="req-resp-toolbar">
											<span class="req-resp-title">Response</span>
											<button type="button" mat-icon-button class="copy-btn"
												(click)="copyResponseJson(row, $event)"
												matTooltip="Copy response JSON"
												[disabled]="!row.cachedResponseJson">
												<mat-icon>content_copy</mat-icon>
											</button>
										</div>
										<pre class="json-block json-block-panel">{{ row.cachedResponseJson || '—' }}</pre>
									</div>
								</div>
							</details>
						</td>
					</tr>
				</ng-container>
				<tr *ngIf="!loading && filteredRows.length === 0">
					<td colspan="13" class="empty-row">No SKUs match the current filter.</td>
				</tr>
			</tbody>
		</table>
	</div>

</div>
